// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { NavItem, RouteType } from '@interfaces/interfaces';
import { AccountType, UserPermissionIds } from '@interfaces/user.interfaces';
import { UserTypes } from '@interfaces/user.interfaces';
import { route as AdminGettingStartedRoute } from '../shared/admin-getting-started/admin-getting-started.component';

export const sideNavMenu: NavItem[] = [
    {
        title: 'Leads',
        route: 'leads',
        type: RouteType.Leads,
        isActive: false,
        icon: 'person',
        accountTypes: [AccountType.ddjDealer, AccountType.stellantisDealer, AccountType.ddjInternal],
        sortOrder: 10,
    },
    {
        title: 'Dashboard',
        route: 'overview',
        type: RouteType.Dashboard,
        isActive: false,
        icon: 'timeline',
        accountTypes: [AccountType.ddjDealer, AccountType.stellantisDealer, AccountType.ddjInternal],
        sortOrder: 20,
    },
    {
        title: 'Consumer Documents',
        route: 'documents',
        type: RouteType.ConsumerDocuments,
        isActive: false,
        icon: 'folder_open',
        accountTypes: [AccountType.ddjDealer, AccountType.stellantisDealer, AccountType.ddjInternal],
        sortOrder: 30,
    },
    {
        title: 'Deals',
        route: 'deals',
        type: RouteType.Deals,
        isActive: false,
        icon: 'directions_car',
        accountTypes: [AccountType.stellantisDealer, AccountType.ddjDealer, AccountType.ddjInternal],
        permissions: {
            userType: [UserTypes.Dealer, UserTypes.Internal],
            permissionIds: [UserPermissionIds.Deals],
        },
        sortOrder: 40,
    },
    {
        title: 'Vehicles',
        route: 'deals',
        type: RouteType.Vehicles,
        isActive: false,
        icon: 'directions_car',
        accountTypes: [AccountType.stellantisBuyer, AccountType.ddjBuyer],
        sortOrder: 50,
    },
    {
        title: 'Document Storage',
        route: 'storage',
        type: RouteType.Storage,
        isActive: false,
        icon: 'warehouse',
        accountTypes: [AccountType.stellantisDealer, AccountType.ddjDealer, AccountType.ddjInternal],
        permissions: {
            userType: [UserTypes.Dealer, UserTypes.Internal],
            permissionIds: [UserPermissionIds.DocumentStorage],
        },
        sortOrder: 60, //30,
    },
    {
        title: 'F&I Forms (Document Library)',
        route: 'forms',
        type: RouteType.Forms,
        isActive: false,
        icon: 'note',
        accountTypes: [AccountType.stellantisDealer, AccountType.ddjDealer, AccountType.ddjInternal],
        permissions: {
            userType: [UserTypes.Dealer, UserTypes.Internal],
            permissionIds: [UserPermissionIds.FAndIForms],
        },
        sortOrder: 70, //90,
    },
    {
        title: 'Document Library Admin',
        route: 'document-library-admin',
        type: RouteType.DocumentLibraryAdmin,
        isActive: false,
        icon: 'folder',
        accountTypes: [AccountType.ddjDealer, AccountType.ddjInternal, AccountType.stellantisDealer],
        permissions: {
            userType: [UserTypes.Dealer, UserTypes.Internal],

            permissionIds: [UserPermissionIds.FAndIForms],
        },
        sortOrder: 80, // 60, //starting internal only items at 100
    },
    //{
    //    title: 'Document Library',
    //    route: 'doc-library',
    //    type: RouteType.DocumentLibrary,
    //    isActive: false,
    //    icon: 'book',
    //    accountTypes: [
    //        AccountType.ddjDealer,
    //        AccountType.ddjInternal,
    //        AccountType.stellantisDealer,
    //    ],
    //    permissions: {
    //        userType: [UserTypes.Dealer, UserTypes.Internal],
    //        permissionIds: [UserPermissionIds.FAndIForms],
    //    },
    //    sortOrder: 50,
    //},
    {
        title: 'Express Upload',
        route: 'express-upload',
        type: RouteType.ExpressUpload,
        isActive: false,
        icon: 'rocket',
        accountTypes: [AccountType.ddjDealer, AccountType.stellantisDealer, AccountType.ddjInternal],
        permissions: {
            userType: [UserTypes.Dealer, UserTypes.Internal],
            permissionIds: [UserPermissionIds.Deals],
        },
        sortOrder: 90, //70,
    },
    {
        title: 'Custom Deal Types',
        route: 'custom',
        type: RouteType.DealTypes,
        isActive: false,
        icon: 'description',
        accountTypes: [AccountType.stellantisDealer, AccountType.ddjDealer, AccountType.ddjInternal],
        permissions: {
            userType: [UserTypes.Dealer, UserTypes.Internal],
            permissionIds: [UserPermissionIds.FAndIForms],
        },
        sortOrder: 100, //90,
    },
    {
        title: 'Getting Started',
        route: AdminGettingStartedRoute,
        type: RouteType.GettingStartedGuide,
        isActive: false,
        icon: 'video_library',
        accountTypes: [AccountType.stellantisDealer, AccountType.ddjDealer, AccountType.ddjInternal],
        sortOrder: 110,
    },
    {
        title: 'Help',
        route: 'help',
        type: RouteType.Help,
        isActive: false,
        icon: 'help',
        accountTypes: [AccountType.stellantisBuyer, AccountType.stellantisDealer, AccountType.ddjBuyer, AccountType.ddjDealer, AccountType.ddjInternal],
        sortOrder: 120,
    },
];

export const userMenu: NavItem[] = [
    {
        title: 'Dealer Management',
        route: 'dealerManagement',
        type: RouteType.DealerManagement,
        isActive: false,
        icon: 'diversity_3',
        accountTypes: [AccountType.stellantisDealer, AccountType.ddjDealer, AccountType.ddjInternal],
        permissions: {
            userType: [UserTypes.Dealer, UserTypes.Internal],
            permissionIds: [UserPermissionIds.DealerInfoManagement],
        },
        sortOrder: 110,
    },
    {
        title: 'User Management',
        route: 'userManagement',
        type: RouteType.UserManagement,
        isActive: false,
        icon: 'group',
        accountTypes: [AccountType.stellantisDealer, AccountType.ddjDealer, AccountType.ddjInternal],
        permissions: {
            userType: [UserTypes.Dealer, UserTypes.Internal],
            permissionIds: [UserPermissionIds.UserAdmin],
        },
        sortOrder: 120,
    },
    {
        title: 'Campaigns',
        route: 'campaigns',
        type: RouteType.Campaigns,
        isActive: false,
        icon: 'campaign',
        accountTypes: [AccountType.stellantisDealer, AccountType.ddjDealer, AccountType.ddjInternal],
        permissions: {
            userType: [UserTypes.Dealer, UserTypes.Internal],
            permissionIds: [UserPermissionIds.DDJAdmin],
        },
        sortOrder: 122,
    },
    {
        title: 'OEM Codes',
        route: 'campaigns/oem',
        type: RouteType.OemCodes,
        isActive: false,
        icon: 'business',
        accountTypes: [AccountType.stellantisDealer, AccountType.ddjDealer, AccountType.ddjInternal],
        permissions: {
            userType: [UserTypes.Dealer, UserTypes.Internal],
            permissionIds: [UserPermissionIds.DDJAdmin],
        },
        sortOrder: 124,
    },
    {
        title: 'Settings',
        route: 'settings',
        type: RouteType.Settings,
        isActive: false,
        icon: 'account_circle',
        accountTypes: [AccountType.stellantisBuyer, AccountType.stellantisDealer, AccountType.ddjBuyer, AccountType.ddjDealer, AccountType.ddjInternal],
        sortOrder: 130,
    },
    {
        title: 'Logout',
        route: 'login',
        type: RouteType.Login,
        isActive: false,
        icon: 'logout',
        accountTypes: [AccountType.stellantisBuyer, AccountType.stellantisDealer, AccountType.ddjBuyer, AccountType.ddjDealer, AccountType.ddjInternal],
        sortOrder: 140,
    },
];

export const stellantisRedirectUrl = 'https://dealeradmin.drivefca.com/admin/dashboard';
